import axios from 'axios';
import { SOURCE } from '@lib/config.js';
import NProgress from 'nprogress';
// import { Message } from 'element-ui';

// TODO: HTTP 配置
const resource = () => {
  // 添加一个请求拦截器
  axios.defaults.withCredentials = true;
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  // axios.defaults.baseURL = 'https://api.example.com';
  // axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
  // axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  axios.interceptors.request.use(request => {
    // TODO: 请求发送前的处理逻辑
    // request.headers()
    // request.url = request.url + '?' + Date.now();
    // 过滤不需要 顶部进度条
    if (request.url.lastIndexOf('multipart') == -1) {
      // NProgress.inc(0.2);
    }

    return request;
  }, error => {
    return Promise.reject(error);
  });
  // 添加一个响应拦截器
  axios.interceptors.response.use(response => {
    // TODO: 返回数据前的处理逻辑
    NProgress.done();
    if (response.data.errCode === 21000) {
      setTimeout(() => {
        if (SOURCE == 'esign') {
          // this.$router.push({ path: '/login' });
          window.location.href = '/login';
          return false;
        }
        window.location.href = response.data.data.redirectUrl;
      }, 500);
    }
    return response;
  }, error => {
    if (error.response) {
      // 请求已经发出，但是服务器响应返回的状态吗不在2xx的范围内
      // console.log(error.response, 'error.response');
      // console.log(error.response.data, 'error.response.data');
      // console.log(error.response.status, 'error.response.status');
      // console.log(error.response.header, 'error.response.header');
      // console.log(error.response.ok, 'error.response.ok');
    } else {
      // 一些错误是在设置请求的时候触发
    }
    return Promise.reject(error);
  });
};

export default resource;



// WEBPACK FOOTER //
// ./src/lib/resource.js